import { FC } from 'react'
import * as Yup from 'yup'

import FormikForm, { FormikFormProps } from '../FormikForm'
import FormikField from '../FormikField'
import FormFieldInput, { FormFieldInputProps } from '../fields/FormFieldInput'
import FormFieldTextArea, {
  FormFieldTextAreaProps,
} from '../fields/FormFieldTextArea'
import FormFieldEmail, { FormFieldEmailProps } from '../fields/FormFieldEmail'
import FormFieldCheckbox, {
  FormFieldCheckboxProps,
} from '../fields/FormFieldCheckbox'

import * as SC from './styled'

export type ContactFormValues = {
  name: string
  lastname: string
  email: string
  message: string
  optin: boolean
}

export type ContactFormProps = FormikFormProps<ContactFormValues> & {
  className?: string
  texts: {
    submitLabel: string
    validationRequired: string
    validationEmail: string
    validationOptin: string
    errorSent?: string
  }
  fields: {
    name: Omit<FormFieldInputProps, 'name'>
    lastname: Omit<FormFieldInputProps, 'name'>
    email: Omit<FormFieldEmailProps, 'name'>
    message: Omit<FormFieldTextAreaProps, 'name'>
    optin: Omit<FormFieldCheckboxProps, 'name'>
  }
}

const ContactForm: FC<ContactFormProps> = ({
  texts,
  fields,
  ...formikProps
}) => {
  const { email, lastname, message, name, optin } = fields

  const validation = Yup.object().shape({
    name: Yup.string().required(texts.validationRequired),
    lastname: Yup.string().required(texts.validationRequired),
    email: Yup.string()
      .email(texts.validationEmail)
      .required(texts.validationRequired),
    optin: Yup.bool()
      .oneOf([true], texts.validationOptin)
      .required(texts.validationRequired),
    message: Yup.string().required(texts.validationRequired),
  })

  return (
    <FormikForm {...formikProps} validationSchema={validation}>
      <SC.Fields>
        <FormikField name="name" Component={FormFieldInput} {...name} />
        <FormikField name="lastname" Component={FormFieldInput} {...lastname} />
        <FormikField name="email" Component={FormFieldEmail} {...email} />
        <FormikField
          name="message"
          Component={FormFieldTextArea}
          {...message}
        />
        <FormikField
          name="optin"
          Component={FormFieldCheckbox}
          type="checkbox"
          {...optin}
        />
      </SC.Fields>
      {texts.errorSent && (
        <SC.StatusMessage $error>{texts.errorSent}</SC.StatusMessage>
      )}
      <SC.Submit type="submit" text={texts.submitLabel} />
    </FormikForm>
  )
}

export default ContactForm
